import { PbPortalSettingsIdentificationFlowEnum } from '@itsrever/rever-api'

export function getOrderParams(
  orderParams: { orderNumber: string; email?: string; postalCode?: string },
  identificationFlow: PbPortalSettingsIdentificationFlowEnum
) {
  const params = new URLSearchParams({
    orderNumber: orderParams.orderNumber
  })

  if (
    identificationFlow ===
    PbPortalSettingsIdentificationFlowEnum.OrderIdAndPostalCode
  ) {
    params.set('postalCode', orderParams.postalCode ?? '')
  } else {
    params.set('email', orderParams.email ?? '')
  }

  return params
}
